import { GlTooltipDirective, GlButton, GlButtonGroup } from '/builds/gitlab/gitlab-ee/node_modules/@gitlab/ui/src/index.js?vue3';
import { cloneDeep } from 'lodash-es';
import { InternalEvents } from '/builds/gitlab/gitlab-ee/app/assets/javascripts/tracking/index.js?vue3';
import { HISTORY_BUTTON_CLICK } from '~/tracking/constants';
import { logError } from '~/lib/logger';
import { captureException } from '~/sentry/sentry_browser_wrapper';
import SafeHtml from '~/vue_shared/directives/safe_html';
import pathLastCommitQuery from 'shared_queries/repository/path_last_commit.query.graphql';
import CiIcon from '/builds/gitlab/gitlab-ee/app/assets/javascripts/vue_shared/components/ci_icon/ci_icon.vue?vue3';
import ClipboardButton from '/builds/gitlab/gitlab-ee/app/assets/javascripts/vue_shared/components/clipboard_button.vue?vue3';
import SignatureBadge from '/builds/gitlab/gitlab-ee/app/assets/javascripts/commit/components/signature_badge.vue?vue3';
import { setupQueryPollingByVisibility } from '~/graphql_shared/utils';
import pipelineStatusUpdatedSubscription from '../subscriptions/pipeline_status_updated.subscription.graphql';
import getRefMixin from '../mixins/get_ref';
import { getRefType } from '../utils/ref_type';
import projectPathQuery from '../queries/project_path.query.graphql';
import eventHub from '../event_hub';
import { FORK_UPDATED_EVENT } from '../constants';
import CommitInfo from '/builds/gitlab/gitlab-ee/app/assets/javascripts/repository/components/commit_info.vue?vue3';
import CollapsibleCommitInfo from '/builds/gitlab/gitlab-ee/app/assets/javascripts/repository/components/collapsible_commit_info.vue?vue3';
const trackingMixin = InternalEvents.mixin();
const POLL_INTERVAL = 30000;
export default {
    name: 'LastCommit',
    components: {
        CiIcon,
        CommitInfo,
        CollapsibleCommitInfo,
        ClipboardButton,
        SignatureBadge,
        GlButtonGroup,
        GlButton
    },
    directives: {
        GlTooltip: GlTooltipDirective,
        SafeHtml
    },
    mixins: [
        getRefMixin,
        trackingMixin
    ],
    apollo: {
        projectPath: {
            query: projectPathQuery
        },
        commit: {
            query: pathLastCommitQuery,
            variables () {
                return {
                    projectPath: this.projectPath,
                    ref: this.ref,
                    refType: getRefType(this.refType),
                    path: this.currentPath.replace(/^\//, '')
                };
            },
            update: (data)=>{
                const lastCommit = data.project?.repository?.lastCommit ?? {};
                const pipelines = lastCommit?.pipelines?.edges;
                return {
                    ...lastCommit,
                    pipeline: pipelines?.length && pipelines[0].node
                };
            },
            result () {
                // Pipeline ID has possiblity of changing every 30 seconds
                const currentPipelineId = this.commit?.pipeline?.id;
                // if current pipeline ID has changed due to polling we need to resubscribe
                if (this.subscribedPipelineId && this.subscribedPipelineId !== currentPipelineId) {
                    if (this.pipelineSubscription?.unsubscribe) {
                        this.pipelineSubscription.unsubscribe();
                    }
                    this.isSubscribed = false;
                }
                // we use a manual subscribeToMore call due to issues with
                // the skip hook not working correctly for the subscription
                if (currentPipelineId && !this.isSubscribed) {
                    this.isSubscribed = true;
                    this.subscribedPipelineId = currentPipelineId;
                    this.pipelineSubscription = this.$apollo.queries.commit.subscribeToMore({
                        document: pipelineStatusUpdatedSubscription,
                        variables: {
                            pipelineId: currentPipelineId
                        },
                        updateQuery (previousData, { subscriptionData: { data: { ciPipelineStatusUpdated } } }) {
                            if (ciPipelineStatusUpdated) {
                                const updatedData = cloneDeep(previousData);
                                const pipeline = updatedData.project?.repository?.lastCommit?.pipelines?.edges[0]?.node || {};
                                pipeline.detailedStatus = ciPipelineStatusUpdated.detailedStatus;
                                return updatedData;
                            }
                            return previousData;
                        }
                    });
                }
            },
            error (error) {
                logError(`Unexpected error while fetching projectInfo query`, error);
                captureException(error);
                throw error;
            },
            pollInterval: POLL_INTERVAL
        }
    },
    props: {
        currentPath: {
            type: String,
            required: false,
            default: ''
        },
        refType: {
            type: String,
            required: false,
            default: null
        },
        historyUrl: {
            type: String,
            required: false,
            default: ''
        }
    },
    data () {
        return {
            projectPath: '',
            commit: null,
            isSubscribed: false,
            subscribedPipelineId: null,
            pipelineSubscription: null
        };
    },
    computed: {
        isLoading () {
            return this.$apollo.queries.commit.loading;
        },
        showCommitId () {
            return this.commit?.sha?.substr(0, 8);
        }
    },
    watch: {
        currentPath () {
            this.commit = null;
        }
    },
    mounted () {
        eventHub.$on(FORK_UPDATED_EVENT, this.refetchLastCommit);
        this.pollingVisibilityCleanup = setupQueryPollingByVisibility(this.$apollo.queries.commit, POLL_INTERVAL);
    },
    beforeDestroy () {
        this.pollingVisibilityCleanup?.();
        eventHub.$off(FORK_UPDATED_EVENT, this.refetchLastCommit);
        if (this.pipelineSubscription?.unsubscribe) {
            this.pipelineSubscription.unsubscribe();
        }
    },
    methods: {
        refetchLastCommit () {
            this.$apollo.queries.commit.refetch();
        },
        handleHistoryClick () {
            this.trackEvent(HISTORY_BUTTON_CLICK);
        }
    }
};
